import { Task } from '@redux-saga/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { all, call } from 'redux-saga/effects';

import { donationsPageSagas } from 'src/pages/DonationSetup/containers/saga';
import { signInOutSagas } from 'src/pages/Account/Profile/Signin/store/saga';
import { anyRequestSagas } from 'src/store/anyRequest/sagas';
import {
  commonSagas,
  getBrandingModelSaga,
  getConfigurationSaga,
  getCurrenciesSaga,
  getCurrentPartnerSaga,
} from 'src/store/commonPart/sagas';
import { getFrontendFeatureFlags } from 'src/store/featureFlags/sagas';
import { GLOBAL_CLEAR_STORE_ACTION } from 'src/store/global';
import { listItemsSagas } from 'src/store/listItemsSaga';
import { sagaMiddleware, store } from 'src/store/store';
import { userSagas } from 'src/store/user/saga';
import { PlusSubscriptionSagas } from 'src/store/plusSubscription/sagas';
import { sidebarSagas } from 'src/containers/Common/saga';
import { accountOrganizerSagas } from 'src/store/organizer/sagas';

function* startAppMinimalSaga() {
  yield getCurrentPartnerSaga(); // further sagas depend on this

  yield all([
    call(getConfigurationSaga),
    call(getBrandingModelSaga),
    call(getFrontendFeatureFlags),
    call(signInOutSagas),
    call(commonSagas),
    call(anyRequestSagas),
    call(userSagas),
    call(getCurrenciesSaga), // probably needed (?)
  ]);
}

function* startAppFullSaga() {
  yield all([
    call(startAppMinimalSaga),
    call(donationsPageSagas),
    call(sidebarSagas),
    call(listItemsSagas),
    call(PlusSubscriptionSagas),
    call(accountOrganizerSagas),
  ]);
}

type SagasPossibleTypes = 'minimal' | 'full';
/** run all project's sagas */
export function* rootSaga(type: SagasPossibleTypes = 'full'): Generator {
  if (type === 'full') {
    yield call(startAppFullSaga);
  } else {
    yield call(startAppMinimalSaga);
  }
}

/** the current saga descriptor to cancel it later (not the best idea) */
let task: Task;

const startApp = (type: SagasPossibleTypes = 'full') => {
  task = sagaMiddleware.run(rootSaga, type);
};

const restartApp = (type: SagasPossibleTypes = 'full') => {
  store.dispatch(GLOBAL_CLEAR_STORE_ACTION as PayloadAction);

  task.cancel();

  startApp(type); // baseLayout
};

/** run/change sagas (depending on a current layout) */
let currentSagasType: SagasPossibleTypes | null = null;
export const changeSagaType = (type: SagasPossibleTypes) => {
  if (currentSagasType === null || currentSagasType !== type) {
    if (currentSagasType === null) {
      startApp(type);
    } else {
      restartApp(type);
    }

    currentSagasType = type;
  }
};
/** end run/change sagas */
